import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  excluir(id, sequencial) {
    if (sequencial == null) {
      // @ts-ignore
      return api.delete(`medico/producao/provisao/${encodeURI(id)}`, null)
    }

    // @ts-ignore
    return api.delete(`/medico/producao/provisao/confirmar/${encodeURI(id)}/procedimento/${encodeURI(sequencial)}`, null)
  },

  efetivarProducao(id, sequencial) {
    if (sequencial == null) {
      return api.put(`medico/producao/provisao/confirmar/${encodeURI(id)}`, null)
    }

    return api.put(`medico/producao/provisao/confirmar/${encodeURI(id)}/procedimento/${encodeURI(sequencial)}`, null)
  },

  listarAgrupadoParaAprovacao(idOperadora, dataEpochInicial, dataEpochFinal) {
    if (idOperadora == null) {
      return api.get(`medico/producao/provisao/aprovar/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}`)
    }

    return api.get(`medico/producao/provisao/aprovar/${encodeURI(dataEpochInicial)}/${encodeURI(dataEpochFinal)}/local/${encodeURI(idOperadora)}`)
  },

  listarLocalExecucao() {
    return api.get('medico/local-execucao')
  },
}
